import { ParametersMethods } from 'sigma-mappings';

export default [
  {
    key: 'sample',
    label: 'fields.engineering.chromatography.sample',
  },
  {
    key: ParametersMethods.GASES_RATIO_2012,
    label: 'enums.engineering.chromatography.methods.nbr-7274.gases-ratio-2012',
  },
  {
    key: ParametersMethods.GASES_RATIO_2015,
    label: 'enums.engineering.chromatography.methods.iec-60599.gases-ratio-2015',
  },
  {
    key: ParametersMethods.TRIANGLE_1,
    label: 'enums.engineering.chromatography.methods.duval.triangle-1',
  },
  {
    key: ParametersMethods.TRIANGLE_4,
    label: 'enums.engineering.chromatography.methods.duval.triangle-4',
  },
  {
    key: ParametersMethods.TRIANGLE_5,
    label: 'enums.engineering.chromatography.methods.duval.triangle-5',
  },
  {
    key: ParametersMethods.ROGERS,
    label: 'enums.engineering.chromatography.methods.ieee-c57-104.rogers',
  },
  {
    key: ParametersMethods.DOERNENBURG,
    label: 'enums.engineering.chromatography.methods.ieee-c57-104.doernenburg',
  },
];
